import type { Value } from 'modules/core/components/MultiFilters/hooks/utils/defaultEvaluators'
import { employeeLegalEntityId } from 'modules/core/lib/employeeLegalEntity'
import type User from 'modules/core/store/models/User'

import { employeeJobTitle } from 'modules/contracts/lib/utils'
import contractVersions from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'
import { employeeJobRole } from 'modules/job_catalog/store/collections/roles'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { employeeTeams } from 'modules/teams/store/employeeTeams'

export default (user: User, value: Value) => {
  const employee = user.isNew
    ? undefined
    : employees.find({
        access_id: user.attributes.id,
      })

  switch (value) {
    case 'employee_status':
      return employee

    case 'user':
      return user

    case 'employee_name':
      return user.fullName()

    case 'location':
      return employee?.attributes.location_id

    case 'team':
      return employee
        ? employeeTeams(teams, memberships, employee.id).map((team) => team.attributes.id)
        : []

    case 'legal_entity':
      return employee && employeeLegalEntityId(employee)

    case 'user_type':
      return (!employee).toString()

    case 'job_title':
      return employee ? employeeJobTitle(contractVersions, employee) : ''
    case 'job_role':
      return employee ? employeeJobRole(contractVersions, employee)?.attributes.name : ''
  }
}
